// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"primary": "#002b5c",
	"primaryLight": "#4fb3ce",
	"secondary": "#4fb3ce",
	"secondaryBright": "#badaf3",
	"accent": "#f37321",
	"neutralLight": "#d9d9d9",
	"neutralBright": "#fff",
	"brandGrey": "#cfd5dd",
	"success": "#095",
	"textColor": "#333",
	"textBright": "#fff",
	"textLinks": "#333",
	"headerColor": "#4fb3ce"
};
module.exports = exports;
